import { render } from "./SettingsDeliveriesAdd.vue?vue&type=template&id=9d73cb34"
import script from "./SettingsDeliveriesAdd.vue?vue&type=script&lang=js"
export * from "./SettingsDeliveriesAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__